<template>
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageaddheader :title="title" :title1="title1" :items="headerItems" />

        <div class="card">
          <div class="card-body">
            <div class="table-top">
              <div class="search-input">
                <a class="btn btn-searchset">
                  <img src="../../../assets/img/icons/search-white.svg" alt="search" />
                </a>
                <input v-model="search" type="search" class="form-control form-control-sm" placeholder="Search by name, email, or role" />
              </div>
              <button class="btn btn-outline-secondary btn-sm" @click="loadUsers" :disabled="loading">
                {{ loading ? 'Refreshing...' : 'Refresh' }}
              </button>
            </div>

            <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
            <div v-if="loading" class="state-wrap">Loading users...</div>

            <div v-else class="table-responsive">
              <table class="table table-hover align-middle">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Location</th>
                    <th>Overrides</th>
                    <th>Effective Permissions</th>
                    <th>Status</th>
                    <th>Last Login</th>
                    <th class="text-end">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="user in filteredUsers" :key="user.id">
                    <td>{{ user.name || '-' }}</td>
                    <td>{{ user.email }}</td>
                    <td>{{ user.role?.rolename || '-' }}</td>
                    <td>{{ user.location?.locationname || '-' }}</td>
                    <td>{{ (user.permission_overrides || []).length }}</td>
                    <td>{{ (user.effective_permissions || []).length }}</td>
                    <td>
                      <span :class="user.is_active ? 'badge bg-success' : 'badge bg-secondary'">
                        {{ user.is_active ? 'Active' : 'Inactive' }}
                      </span>
                    </td>
                    <td>{{ formatDate(user.last_login) }}</td>
                    <td class="text-end">
                      <router-link v-if="canEditUsers" class="me-3" :to="{ name: 'newuseredit', query: { id: user.id } }">
                        <img src="../../../assets/img/icons/edit.svg" alt="edit" />
                      </router-link>
                      <a v-if="canDeleteUsers" href="javascript:void(0);" @click="removeUser(user)">
                        <img src="../../../assets/img/icons/delete.svg" alt="delete" />
                      </a>
                    </td>
                  </tr>
                  <tr v-if="!filteredUsers.length">
                    <td colspan="9" class="text-center text-muted py-4">No users found.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
  name: 'userlists',
  data() {
    return {
      title: 'User Management',
      title1: 'Manage users, roles, and overrides',
      search: '',
      users: [],
      loading: false,
      errorMessage: '',
    };
  },
  computed: {
    headerItems() {
      return this.$store.getters.hasPermission('users.add')
        ? [{ text: 'Add User', addname: '/newuser' }]
        : [];
    },
    canEditUsers() {
      return this.$store.getters.hasPermission('users.edit');
    },
    canDeleteUsers() {
      return this.$store.getters.hasPermission('users.delete');
    },
    filteredUsers() {
      const term = this.search.trim().toLowerCase();
      if (!term) {
        return this.users;
      }

      return this.users.filter((user) => {
        const haystack = [
          user.name,
          user.email,
          user.role?.rolename,
        ].join(' ').toLowerCase();
        return haystack.includes(term);
      });
    },
  },
  methods: {
    formatDate(value) {
      if (!value) {
        return '-';
      }
      const date = new Date(value);
      return Number.isNaN(date.getTime())
        ? value
        : date.toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' });
    },
    async loadUsers() {
      this.loading = true;
      this.errorMessage = '';
      try {
        const response = await axios.get('/v1/users');
        this.users = response.data || [];
      } catch (error) {
        this.errorMessage = error.response?.data?.detail || 'Failed to load users.';
      } finally {
        this.loading = false;
      }
    },
    async removeUser(user) {
      const result = await Swal.fire({
        title: 'Delete user?',
        text: `This will remove ${user.email}.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#FF9F43',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete',
      });

      if (!result.isConfirmed) {
        return;
      }

      try {
        await axios.delete(`/v1/users/${user.id}`);
        this.users = this.users.filter((item) => item.id !== user.id);
        Swal.fire({ icon: 'success', title: 'Deleted', timer: 1200, showConfirmButton: false });
      } catch (error) {
        Swal.fire({ icon: 'error', title: 'Delete failed', text: error.response?.data?.detail || 'Could not delete user.' });
      }
    },
  },
  mounted() {
    this.loadUsers();
  },
};
</script>

<style scoped>
.table-top { display:flex; align-items:center; justify-content:space-between; gap:12px; margin-bottom:16px; flex-wrap:wrap; }
.search-input { display:flex; align-items:center; gap:6px; min-width:280px; }
.search-input input { max-width:360px; }
.state-wrap { padding:24px; color:#6b7280; }
</style>
